<div class="header-title">{{ title() }}</div>
@if (!buttonsHidden()) {
  <div
    class="header-button"
    id="video-icon-wrapper"
    (click)="buttonClick.emit({ type: HeaderButtonTypeEnum.Video })"
    role="button"
    tabindex="HeaderButtonTypeEnum.Video">
    <orbit-fa-icon id="video-icon" [iconName]="videoIcon" />
  </div>
  <div
    class="header-button"
    id="call-icon-wrapper"
    (click)="buttonClick.emit({ type: HeaderButtonTypeEnum.Call })"
    role="button"
    tabindex="HeaderButtonTypeEnum.Call">
    <orbit-fa-icon id="call-icon" [iconName]="phoneIcon" />
  </div>
  <div
    class="header-button"
    id="list-expand-icon-wrapper"
    role="button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="buttonClick.emit({ eventOrigin: trigger, type: HeaderButtonTypeEnum.OpenList })"
    tabindex="HeaderButtonTypeEnum.OpenList">
    <orbit-fa-icon id="list-expand-icon" [iconName]="ellipsisIcon" />
  </div>
}
